import "./cookie/cookieOverrideStyleScgp.css";

import appleTouchIcon from "@assets/favicons/apple-touch-icon.png";
import favicon16 from "@assets/favicons/favicon-16x16.png";
import favicon32 from "@assets/favicons/favicon-32x32.png";
import safariPinnedTab from "@assets/favicons/safari-pinned-tab.svg";
import { useUser } from "@saleor/auth";
import {
  APP_ENV,
  DD_APPLICATION_ID,
  DD_CLIENT_TOKEN,
  DD_SITE,
  SHOW_COOKIES_BANNER
} from "@saleor/config";
import { ShopInfoQuery, useShopInfoQuery } from "@saleor/graphql";
import { datadogScript } from "@saleor/utils/datadog";
import React from "react";
import Helmet from "react-helmet";

import CookieConsent from "./cookie/CookieConsent";

type ShopContext = ShopInfoQuery["shop"];

export const ShopContext = React.createContext<ShopContext>(undefined);

export const ShopProvider: React.FC = ({ children }) => {
  const { authenticated } = useUser();
  const { data } = useShopInfoQuery({
    skip: !authenticated
  });

  return (
    <>
      <Helmet>
        <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
        <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
        <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
        <link rel="mask-icon" href={safariPinnedTab} />

        {DD_APPLICATION_ID && DD_CLIENT_TOKEN && DD_SITE && (
          <script>{`${datadogScript}`}</script>
        )}

        {/* Cookies */}
        {SHOW_COOKIES_BANNER && (
          <script
            type="text/javascript"
            src={
              APP_ENV === "PROD"
                ? "https://scgppdpa.scgpco.com/v1/privacy-managers/51056097048/reddot.js"
                : "https://scgppdpa-test.scgpco.com/v1/privacy-managers/51054097048/reddot.js"
            }
          ></script>
        )}
        <script
          defer
          src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js"
          integrity="sha512-bLT0Qm9VnAYZDflyKcBaQ2gg0hSYNQrJ8RilYldYQ1FxQYoCLtUjuuRuZo+fjqhx/qtq/1itJ0C2ejDxltZVFg=="
          crossOrigin="anonymous"
        ></script>
        {/*  */}
      </Helmet>
      <ShopContext.Provider value={data ? data.shop : undefined}>
        {children}
      </ShopContext.Provider>
      {SHOW_COOKIES_BANNER && <CookieConsent lang="en" />}
    </>
  );
};

export const Shop = ShopContext.Consumer;
export default Shop;
